import { render, staticRenderFns } from "./many.vue?vue&type=template&id=b573f2c0&scoped=true&"
import script from "./many.vue?vue&type=script&lang=js&"
export * from "./many.vue?vue&type=script&lang=js&"
import style0 from "./many.vue?vue&type=style&index=0&id=b573f2c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b573f2c0",
  null
  
)

export default component.exports